;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      deviceIPAddress: '',
      error: null,
      isLoading: false
    };
  },

  methods: {
    getUserIp: async function getUserIp() {
      this.isLoading = true;
      this.error = null;

      try {
        var response = await fetch('https://api.ipify.org?format=json');
        var data = await response.json();
        this.deviceIPAddress = data.ip;
        this.$emit('ip-address', this.deviceIPAddress);
      } catch (error) {
        this.error = 'Error fetching IP address: ' + error.message;
        this.deviceIPAdress = "";
      } finally {
        this.isLoading = false;
        this.deviceIPAdress = "";
      }
    }
  },
  mounted: function mounted() {
    this.getUserIp();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"device_ip_address"},domProps:{"value":_vm.deviceIPAddress}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"ip_error"},domProps:{"value":_vm.error}})])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2fd7f176", __vue__options__)
  } else {
    hotAPI.reload("data-v-2fd7f176", __vue__options__)
  }
})()}